import { render, staticRenderFns } from "./FSubAreaDialog.vue?vue&type=template&id=64fa1571&scoped=true"
import script from "./FSubAreaDialog.vue?vue&type=script&lang=js"
export * from "./FSubAreaDialog.vue?vue&type=script&lang=js"
import style0 from "./FSubAreaDialog.vue?vue&type=style&index=0&id=64fa1571&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa1571",
  null
  
)

export default component.exports